// What `$sanitize` keeps in v-html content. Any other tag is dropped, but its
// text stays: a <ul> list ends up as names glued together.
export default {
  allowedTags: ['img', 'span', 'div', 'i', 'br', 'b', 'strong', 'a'],
  allowedAttributes: {
    '*': ['class', 'style'],
    img: ['src', 'class'],
    a: ['href', 'target']
  },
  allowedSchemes: ['data', 'http', 'https']
}
